import { GetRowKey, ReorderRow, RowKey } from '../types';

export const reorderRows = <T, K extends RowKey = RowKey>(
  { rowKey, newIndex }: ReorderRow<K>,
  data: T[],
  key: GetRowKey<T, K> | K
): T[] => {
  const getRowKey =
    typeof key === 'function' ? key : (row: any): any => row[key];
  const arr = [...data];
  const [removedElement] = arr.splice(
    data.findIndex((row) => getRowKey(row) === rowKey),
    1
  );
  arr.splice(newIndex, 0, removedElement);
  return arr;
};
